import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import ScrollToTopPage from '../../components/ScrollToTopPage';
import services from './options';
import ServiceBlock from '../../components/ServiceBlock';
import NeedMoreHelpSection from '../../components/NeedMoreHelpSection';

import styles from './Homepage.module.scss';

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <>
      <ScrollToTopPage />
      <div className={styles.contentviewport}>
        <div className={styles.contentContainer}>
          <Typography className={styles.title}>{t('home.onlineServices.title')}</Typography>
          <Grid container spacing={3}>
            {Object.keys(services).map((key) => (
              <Grid item key={key} xs={12} lg={6}>
                <ServiceBlock
                  serviceKey={`home.onlineServices.data.${key}`}
                  service={services[key]}
                />
              </Grid>
            ))}
          </Grid>
          <NeedMoreHelpSection />
        </div>
      </div>
    </>
  );
};

export default HomePage;
